import { useState, useMemo, useEffect, useRef } from 'react'
import { MapContainer, TileLayer, Polyline, Tooltip, CircleMarker } from 'react-leaflet'
import http from 'http'

import 'leaflet/dist/leaflet.css'

import getRegion from  'fn/getRegion'

const Map = ( {
  route,
  color,
  point,
  label,
  value
} ) => {
  const center = [ 19.320772, -99.151468 ]
  const [ points, setPoints ] = useState()
  const map = useRef()

  useMemo( () => {
    http( {
      method: 'GET',
      url: `/track/${ route.at }`,
      params: {
        __select: 'points'
      }
    } )
      .then( ( { data } ) => {
        setPoints( points => {
          const aux = data.points
            .map( p => ( [ p.latitude, p.longitude ] ) )

          return aux
        } )

      } )

  }, [] )

  useEffect( () => {
    if ( points && points.length === 0 ) return

    if ( ! map.current ) return

    const region = getRegion( points )

    map.current.fitBounds( region )
  }, [ points ] )

  return <div className="one hs">
    <MapContainer
      ref={ map }
      className="one"
      center={ center }
      zoom={ 16 }
      scrollWheelZoom={ true }
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
      />

      { points ? <Polyline
        positions={ points }
        pathOptions={ {
          color
        } }
      /> : null }

      { point ? <CircleMarker
        center={ point.point }
        radius={ 7 }
        pathOptions={ { color, fill: true } }
      >
        <Tooltip
          direction="auto"
          offset={[14, 0]}
          opacity={1}
          permanent
          className="map-tooltip"
        >
          <div className="hs">
            <div className="vs ai-center gap">
              <strong>
                { label.title }
              </strong>

              <label>
                { point[ label.key ] } { label.units || '' }
              </label>
            </div>

            <div className="vs ai-center gap">
              <strong>
                { value.title }
              </strong>

              <label>
                { point[ value.key ] } { value.units || '' }
              </label>
            </div>

          </div>
        </Tooltip>
      </CircleMarker> : null }

    </MapContainer>
  </div>
}

export default Map
